import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=0f206777&scoped=true&"
import script from "./homeIndex.vue?vue&type=script&lang=js&"
export * from "./homeIndex.vue?vue&type=script&lang=js&"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=0f206777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f206777",
  null
  
)

export default component.exports